@if (!isLoading) {

  <app-components-specialist-actioncomponents-page-optimization-shared-instructions
    [taskId]="taskId"
    [websiteUrlId]="websiteUrlId"
    [googleSearchUrl]="customer.Country.GoogleSearchUrl"
    [showNotesForContentWriter]="false">
  </app-components-specialist-actioncomponents-page-optimization-shared-instructions>

  <app-components-specialist-actioncomponents-page-optimization-shared-notes
    [customer]="customer"
    [taskId]="taskId"
    [currentNoteType]="TaskNoteTypes.ImplementationFeedback"
    [workflowId]="workflowId">
  </app-components-specialist-actioncomponents-page-optimization-shared-notes>

  <app-components-specialist-actioncomponents-page-optimization-shared-audit
    [orderingTask]="orderingTask"
    [workflowId]="workflowId"
    [taskId]="taskId"
    [userId]="userId"
    [customerId]="customer.CustomerId"
    [websiteUrlId]="websiteUrlId"
    [isReadOnly]="true">
  </app-components-specialist-actioncomponents-page-optimization-shared-audit>

  <app-components-specialist-actioncomponents-page-optimization-shared-content
    [orderingTask]="orderingTask"
    [workflowId]="workflowId"
    [taskId]="taskId"
    [userId]="userId"
    [customerId]="customer.CustomerId"
    [websiteUrlId]="websiteUrlId"
    [isReadOnly]="true">
  </app-components-specialist-actioncomponents-page-optimization-shared-content>

  <app-components-specialist-actioncomponents-page-optimization-shared-floating-panels
    [orderingTask]="orderingTask"
    [customer]="customer"
    [taskId]="taskId"
    [showExternalAccess]="true"
    [showInformation]="true"
    [showTaskFiles]="true">
  </app-components-specialist-actioncomponents-page-optimization-shared-floating-panels>

  <app-components-specialist-actioncomponents-page-optimization-shared-implementation-url
    [orderingTask]="orderingTask"
    [workflowId]="workflowId"
    [websiteUrlId]="websiteUrlId"
    [customerId]="customer.CustomerId"
    [customerUrl]="customer.Url"
    [isReadOnly]="true">
  </app-components-specialist-actioncomponents-page-optimization-shared-implementation-url>

  <app-components-specialist-actioncomponents-page-optimization-shared-note
    [userId]="userId"
    [taskId]="taskId"
    [label]="'Implementation Feedback'"
    [noteType]="TaskNoteTypes.ImplementationFeedback">
  </app-components-specialist-actioncomponents-page-optimization-shared-note>

  <app-components-specialist-actioncomponents-page-optimization-shared-checklist
    [taskId]="taskId">
  </app-components-specialist-actioncomponents-page-optimization-shared-checklist>
}
